class CampaignCache {
  constructor() {
    this.prefix = 'campaign_'
    this.defaultTTL = 5 * 60 * 1000

    // 內存緩存層 (L1 cache)
    this.memoryCache = new Map()
    this.maxMemoryItems = 20
  }

  set(key, data, customTTL = null) {
    const item = this.createCacheItem(data, customTTL || this.defaultTTL)

    // 管理內存容量並設定
    this.setMemoryCache(key, item)

    try {
      sessionStorage.setItem(this.getStorageKey(key), JSON.stringify(item))
    } catch (error) {
      console.error('Failed to set cache:', error)
    }
  }

  get(key) {
    // L1: 先檢查內存緩存
    if (this.memoryCache.has(key)) {
      const memItem = this.memoryCache.get(key)
      if (!this.isExpired(memItem)) {
        // 更新訪問順序 (LRU)
        this.updateAccessOrder(key, memItem)
        return memItem.data
      }
      // 內存中的項目過期，移除
      this.memoryCache.delete(key)
    }

    // L2: 檢查 sessionStorage
    try {
      const item = sessionStorage.getItem(this.getStorageKey(key))
      if (!item) return null

      const cacheItem = JSON.parse(item)

      if (this.isExpired(cacheItem)) {
        this.remove(key)
        return null
      }

      // 將有效數據加入內存緩存
      this.addToMemoryCache(key, cacheItem.data, cacheItem.ttl, cacheItem.timestamp)
      return cacheItem.data
    } catch (error) {
      this.remove(key)
      return null
    }
  }

  remove(key) {
    // 同時從內存和 sessionStorage 移除
    this.memoryCache.delete(key)
    try {
      sessionStorage.removeItem(this.getStorageKey(key))
    } catch (error) {
      console.error('Failed to remove cache:', error)
    }
  }

  clear() {
    try {
      // 清空內存緩存
      this.memoryCache.clear()

      // 清空 sessionStorage
      Object.keys(sessionStorage)
        .filter(key => key.startsWith(this.prefix))
        .forEach(key => sessionStorage.removeItem(key))
    } catch (error) {
      console.error('Failed to clear cache:', error)
    }
  }

  // === 工具方法 ===
  createCacheItem(data, ttl, timestamp = null) {
    return {
      data,
      timestamp: timestamp || Date.now(),
      ttl
    }
  }

  isExpired(item) {
    return Date.now() - item.timestamp > item.ttl
  }

  getStorageKey(key) {
    return this.prefix + key
  }

  // === 內存緩存管理 ===
  setMemoryCache(key, item) {
    // 如果內存已滿，移除最舊的項目 (LRU)
    if (this.memoryCache.size >= this.maxMemoryItems) {
      const firstKey = this.memoryCache.keys().next().value
      this.memoryCache.delete(firstKey)
    }

    // 添加到內存緩存
    this.memoryCache.set(key, item)
  }

  updateAccessOrder(key, item) {
    // 先刪除再設定，將項目移到 Map 的末尾 (最新訪問)
    this.memoryCache.delete(key)
    this.memoryCache.set(key, item)
  }

  addToMemoryCache(key, data, ttl, timestamp = null) {
    const item = this.createCacheItem(data, ttl, timestamp)
    this.setMemoryCache(key, item)
  }
}

export const campaignCache = new CampaignCache()